import { FC, useState } from 'react';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useGetUserQuery, useTrackEventMutation } from 'src/common/slices';
import { CertificateFullNameModal } from 'src/common/components/certificate-full-name-modal';
import { ApiResponseStatus } from 'src/common/enums';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { StyledButton } from '../room-banner-actions/room-banner-actions.styles';
import { CertificateProps, CertificateType } from './certificate.type';
import { useGetExistingCertificateQuery, useCreateCertificateMutation } from './certificate.slice';
const Certificate: FC<CertificateProps> = ({
  roomCode,
  roomProgress
}) => {
  const {
    data: userSelf
  } = useGetUserQuery();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [getCertificate, {
    isLoading: isLazyCertificateLoading
  }] = useCreateCertificateMutation();
  const [trackEvent] = useTrackEventMutation();
  const userFullName = userSelf?.data?.user.fullName;
  const isCompletedRoom = roomProgress === 100;
  const {
    data: certificateResponse,
    isLoading: isCertificateLoading
  } = useGetExistingCertificateQuery({
    code: roomCode,
    type: CertificateType.ROOM
  }, {
    skip: !isCompletedRoom
  });
  const isCertificateAvailable = certificateResponse?.status === ApiResponseStatus.SUCCESS && Boolean(certificateResponse?.data?.certId);
  const handleCertificate = async () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'click-certificate-cta'
    });
    if (certificateResponse?.data?.certId) {
      window.open(`/r/certificate/${certificateResponse?.data?.certId}`, '_blank');
      return;
    }
    NotificationDispatch('info', 'Fetching certificate, please wait.');
    try {
      const response = await getCertificate({
        code: roomCode,
        type: CertificateType.ROOM
      });
      if ('data' in response && response?.data?.status === ApiResponseStatus.SUCCESS && response?.data?.data?.certId) {
        window.open(`/r/certificate/${response.data.data.certId}`, '_blank');
        NotificationDispatch('success', 'Certificate generated successfully.');
      } else {
        NotificationDispatch('error', 'You have not earned this certificate yet.');
      }
    } catch (error) {
      if (isQueryErrorWithMessage(error)) {
        NotificationDispatch('error', error.data.message);
      } else {
        NotificationDispatch('error', 'Issue retrieving certificate');
      }
    }
  };
  if (!userSelf) return null;
  if (!isCompletedRoom) return <StyledButton variant="outlined" color="secondary"
  // eslint-disable-next-line react/jsx-no-bind
  onClick={NotificationDispatch.bind(null, 'error', 'You have not earned this certificate yet.')}>
        Certificate
      </StyledButton>;
  if (userFullName || isCertificateAvailable) return <StyledButton variant="outlined" color="secondary"
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  onClick={handleCertificate}>
        Certificate
      </StyledButton>;
  return <>
      <StyledButton onClick={() => {
      setIsModalOpen(true);
    }} data-testid="certificate-button-modal" variant="outlined" color="secondary" data-sentry-element="StyledButton" data-sentry-source-file="certificate.tsx">
        Certificate
      </StyledButton>
      <CertificateFullNameModal
    /* eslint-disable-next-line @typescript-eslint/no-misused-promises */ handleCertificate={handleCertificate} isCertificateLoading={isCertificateLoading || isLazyCertificateLoading} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data-sentry-element="CertificateFullNameModal" data-sentry-source-file="certificate.tsx" />
    </>;
};
export { Certificate };